import { STORE_FEATURE_FLAGS } from '../constants/actionTypes'

const initialState = {}

const featureFlagReducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_FEATURE_FLAGS:
      return Object.assign({}, state, action.flags)
    default:
      return state
  }
}

export default featureFlagReducer
export { initialState }
